module.exports = __webpack_public_path__ + "static/media/pcamel.7877017f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/pcamel.jpg
// module id = 254
// module chunks = 0